<template>
  <section :class="isMobile ? 'repair-step mobile-repair-step' : 'repair-step'">
    <div class="title">机器维修（生产）</div>

    <div class="form">
      <!-- <div class="form-item">
        <div class="label">解决方法</div>
        <div class="text-area-data">
          <a-textarea
            v-model:value="problemForm.processRecords"
            placeholder="请输入解决方法"
            :disabled="!isEdit"
            allow-clear
          />
        </div>
      </div> -->
      <div class="form-item">
        <div class="step-label">更换故障隐患零配件清单</div>
        <div class="upload-data">
          <upload-img-vue
            :attachment="problemForm.annex"
            :disabled="!isEdit"
            ref="uploadAnnex"
          ></upload-img-vue>
        </div>
      </div>

      <div class="form-item">
        <div class="step-label">维修清单</div>
        <rectification-vue
          ref="rectificationRef"
          :echoObj="problemForm"
          :disabled="!isEdit"
        ></rectification-vue>
      </div>

      <content-dsc-vue
        :rootCauseAnalyses="problemForm.solution"
        ref="resolvent"
        :formdata="problemForm"
        title="解决方法"
        :disabled="!isEdit"
        type="3"
      >
      </content-dsc-vue>
      <!-- <div class="form-item">
        <div class="label">添加图片</div>
        <div class="upload-data">
          <upload-img-vue
            :attachment="problemForm.pictrue"
            :disabled="!isEdit"
            ref="uploadImg"
          ></upload-img-vue>
        </div>
      </div>
      <div class="form-item">
        <div class="label">添加视频</div>
        <div class="upload-data">
          <upload-video-vue
            :attachment="problemForm.video"
            :disabled="!isEdit"
            ref="uploadVideo"
          ></upload-video-vue>
        </div>
      </div> -->
      <div class="form-item">
        <a-space
          :size="20"
          :direction="isMobile ? 'vertical' : 'horizontal'"
          style="flex-wrap: wrap"
        >
          <div class="df">
            <div class="step-label">新编号</div>
            <div class="data">
              <a-input
                v-model:value="machineInfo.newCode"
                placeholder="请输入新编码"
                :disabled="!isEdit"
                allow-clear
              />
            </div>
          </div>
          <div class="df">
            <div class="step-label">完成时间</div>
            <div class="data">
              <select-day-vue
                :defaultVal="problemForm.completeDate"
                @userDelectDay="userDelectDay"
                :disabled="!isEdit"
              ></select-day-vue>
            </div>
          </div>
          <div class="df">
            <div class="step-label">经手人</div>
            <div class="data">
              <a-input
                v-model:value="problemForm.principal"
                placeholder="请输入经手人"
                :disabled="!isEdit"
                allow-clear
              ></a-input>
            </div>
          </div>
          <div class="df" v-if="problemForm.rollbackReason">
            <div class="step-label">回退原因</div>
            <div class="data">
              <a-input
                v-model:value="problemForm.rollbackReason"
                :disabled="true"
              ></a-input>
            </div>
          </div>
          <div class="df" v-if="problemForm.username">
            <div class="step-label">编辑人</div>
            <div class="data">
              {{ problemForm.username }}
            </div>
          </div>
        </a-space>
      </div>
    </div>

    <div class="footer df both-side">
      <a-button type="primary" @click="saveInfo" :disabled="!isEdit"
        >保存</a-button
      >
      <a-space :size="isMobile ? 10 : 50">
        <a-button @click="nextStep" :disabled="!isEdit">下一步</a-button>
        <a-button @click="backPreStep" :disabled="!isEdit" type="danger"
          >退回上一级</a-button
        >
      </a-space>
    </div>
  </section>

  <roll-back-modal-vue
    ref="rollBackModal"
    @rollBack="rollBack"
  ></roll-back-modal-vue>
</template>

<script>
import { defineComponent, reactive, watch, ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import {
  updateMachineMaintenance,
  machineMaintenanceConfirm,
  machineMaintenanceRollback,
  saveOrUpdateRepairEquipment,
} from "@/request/view/repair";
import { Toast, showUploading, hideUploading } from "@/utils/index";
import { showModal } from "../serve/modal";
import uploadImgVue from "./uploadImg.vue";
import uploadVideoVue from "./uploadVideo.vue";
import selectDayVue from "./selectDay.vue";
import rollBackModalVue from "./rollBackModal.vue";
import contentDscVue from "./contentDsc.vue";
// import rectificationVue from "./rectification.vue";
import rectificationVue from "./maintenance.vue";

export default defineComponent({
  components: {
    uploadImgVue,
    uploadVideoVue,
    selectDayVue,
    rollBackModalVue,
    contentDscVue,
    rectificationVue,
  },
  props: {
    progress: Object,
    machine: Object,
    meta: Object,
  },
  setup(props, context) {
    const router = useRouter();
    const back = () => {
      // router.replace("/repairequipment");
      context.emit("back");
    };
    const store = useStore();

    const isMobile = computed(() => store.state.isMonile);

    const problemForm = reactive({
       annex: null,
        calibrateDate: null,
        calibrateDesc: null,
        calibrateRepair: null,
        calibrateSign: null,
        completeDate: null,
        gzHost: null,
        completeReferenceArmPencil: null,
        threeMajorItemsPencil: null,
        instrumentCalibrate: null,
        completeReferenceArmDate: null,
        completeReferenceArmDesc: null,
        completeReferenceArmRepair: null,
        completeReferenceArmSign: null,
        debugLevel: null,
        detector: null,
        girdling: null,
        host: null,
        id: null,
        isEditable: null,
        isReferenceArmQualified: null,
        measured25Mid: null,
        measured25Tail: null,
        networkCable: null,
        opticalFiber: null,
        polarization: null,
        principal: null,
        referenceArmDate: null,
        referenceArmDesc: null,
        referenceArmMakeDate: null,
        referenceArmRepair: null,
        referenceArmRetestDate: null,
        referenceArmSign: null,
        repairEquipmentId: null,
        completeReferenceArmNet: null,
        rollbackReason: null,
        screen: null,
        smaCable: null,
        solution: null,
        theory25Mid: null,
        threeMajorItemsDate: null,
        threeMajorItemsDesc: null,
        threeMajorItemsRepair: null,
        threeMajorItemsSign: null,
        type: null,
        userId: null,
        username: null,
    });
    const getEditLock = () => {
      const { id, username } = store.state.user.user;
      if (problemForm.userId === null && problemForm.username === null) {
        return true;
      } else if (problemForm.userId == id) {
        return true;
      }
      return false;
    };
    const isEdit = computed(() => {
      if (store.getters.user) {
        const unlock = getEditLock();
        return (
          props.meta["/produceupdateInfo"] &&
          machineInfo.repairProcess == 3 &&
          unlock
        );
      }
      return false;
    });
    const uploadImg = ref();
    const uploadVideo = ref();
    const rollBackModal = ref();
    const uploadAnnex = ref();
    const resolvent = ref();
    const rectificationRef = ref();
    const machineInfo = reactive({
      id: null,
      repairProcess: null,
      newCode: null,
    });

    // 更换替换设备/设备返厂
    const updateMachine = () => {
      if (!machineInfo.newCode) {
        return 
      }
      saveOrUpdateRepairEquipment({
        id: machineInfo.id,
        newCode: machineInfo.newCode,
      })
        .then((res) => {
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const saveInfo = async () => {
      const retification = rectificationRef.value.getRetificationData();

      showUploading("上传中");
      updateMachine();
      //上传附件
      let annex = null;
      await uploadAnnex.value
        .uploadFile()
        .then((res) => {
          // console.log(res);
          annex = JSON.stringify(res);
        })
        .catch((err) => {
          console.log(err);
          hideUploading();
        });

      //维修方案
      await resolvent.value
        .uploadContent()
        .then()
        .catch((err) => {
          console.log(err);
          hideUploading();
        });

      const reqObj = Object.assign(
        {
          annex,
          completeDate: problemForm.completeDate,
          id: problemForm.id,
          isEditable: problemForm.isEditable,
          principal: problemForm.principal,
          processRecords: problemForm.processRecords,
          repairEquipmentId: machineInfo.id,
          rollbackReason: problemForm.rollbackReason,
          userId: store.state.user.user.id,
          username: store.state.user.user.username,
          type: 3,
        },
        retification
      );
      updateMachineMaintenance(reqObj)
        .then((res) => {
          context.emit("resetProcess");
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          problemForm.id = res.data.id;
          hideUploading();
        })
        .catch((err) => {
          console.log(err);
          hideUploading();
        });
    };

    const nextStep = () => {
      showModal({
        title: "提示",
        toastText: "请先保存信息再确认到下一步流程？",
        success: () => {
          machineMaintenanceConfirm({
            machineMaintenanceId: problemForm.id,
          })
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200 && res.message === "成功") {
                context.emit("updateMachineInfo");
                context.emit("updateProcess", res.data);
                back();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const rollBack = (e) => {
      machineMaintenanceRollback({
        machineMaintenanceId: problemForm.id,
        rollbackReason: e,
      })
        .then((res) => {
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          if (res.code === 200) {
            rollBackModal.value.handleCancel();
            context.emit("updateMachineInfo");
            // context.emit("updateProcess", res.data);
            back();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const backPreStep = () => {
      rollBackModal.value.showModal();
      rollBackModal.value.setInputData(problemForm.rollbackReason);
    };

    const userDelectDay = (day) => {
      problemForm.completeDate = day;
    };

    const setProblemData = (data) => {
      Object.keys(problemForm).forEach((key) => {
        problemForm[key] = data[key];
      });
    };

    watch(
      () => props.progress,
      (val) => {
        setProblemData(val);
      },
      {
        immediate: true,
        deep: true,
      }
    );
    watch(
      () => props.machine,
      (val) => {
        machineInfo.id = val.id;
        machineInfo.repairProcess = val.repairProcess;
        machineInfo.newCode = val.newCode;
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      problemForm,
      saveInfo,
      nextStep,
      backPreStep,
      userDelectDay,
      machineInfo,
      uploadImg,
      uploadVideo,
      rollBack,
      uploadAnnex,
      isEdit,
      rollBackModal,
      resolvent,
      isMobile,
      rectificationRef,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
